import React from "react";
import {useForm} from "react-hook-form";
import moment from "moment";
import {Box, Button, Checkbox, Grid, ListItem, ListItemButton, ListItemText, Modal, Typography} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import {getPTORequestList, setPTORequestUpdate} from "../../api/client";

const CalendarBody = React.memo((props) => {
  const calendar = [];
  const wdArr = ["日", "月", "火", "水", "木", "金", "土"];
  for(let day = moment(props.state.date).startOf("month").format(); day <= moment(props.state.date).endOf("month").format(); day = moment(day).add(1, "d").format()) {
    let color = "rgba(0, 0, 0, 0.23)";
    if (moment(day).format("d") === "0" || props.getValues(moment(day).format("D")).hdFg) {
      color = "rgba(232, 122, 144, 1.0)";
    } else if (moment(day).format("d") === "6") {
      color = "rgba(81, 168, 221, 1.0)";
    };
    if (moment(day).format("D") === "1") {
      for (let weekh = 0; weekh <= 6; weekh++) {
        let wdColor = "rgba(0, 0, 0, 0.1)";
        if (weekh === 0) {
          wdColor = "rgba(232, 122, 144, 0.3)";
        } else if (weekh === 6) {
          wdColor = "rgba(81, 168, 221, 0.3)";
        };
        calendar.push(
          <Grid
            item
            key = {"week" + weekh}
            sx = {{p: 0.1}}
            xs = {12 / 7}
          >
            <ListItem
              sx = {{height: 40, p: 0, borderRadius: 1.2, bgcolor: wdColor}}
            >
              <ListItemText
                sx = {{m: "auto", textAlign: "center"}}
              >
                {wdArr[weekh]}
              </ListItemText>
            </ListItem>
          </Grid>
        );
      };
      for (let weekb = 0; weekb < parseInt(moment(day).format("d")); weekb++) {
        calendar.push(
          <Grid
            item
            key = {"blank" + weekb}
            xs = {12 / 7}
          >
          </Grid>
        );
      };
    };
    calendar.push(
      <Grid
        item
        key = {moment(day).format("D")}
        xs = {12 / 7}
      >
        <ListItemButton
          disabled = {props.state.date <= props.limitDate || props.getValues(moment(day).format("D")).ptoStatus === "2" || props.getValues(moment(day).format("D")).ptoStatus === "3"}
          onClick = {() => document.getElementById("ckbox_" + moment(day).format("D")).click()}
          sx = {{height: 80, p: 0, border: "1px solid " + color, borderRadius: 1.2, borderTop: "4px solid " + color}}
        >
          <ListItemText
            primary = {moment(day).format("D")}
            primaryTypographyProps = {{component: "div", sx: {float: "left", width: "100%"}}}
            secondary = {
              <React.Fragment>
                <Typography
                  color = {props.getValues(moment(day).format("D")).ptoStatus === "2" ? "accentM.main" : ""}
                >
                  {props.getValues(moment(day).format("D")).ptoStatus === "2" ? "承認" : props.getValues(moment(day).format("D")).ptoStatus === "3" ? "否認" : ""}
                </Typography>
                <Checkbox
                  icon = {
                    <CheckIcon
                      color = "accentY"
                      fontSize = "large"
                      sx = {{float: "right", mr: "0.3rem", opacity: 0}}
                    />
                  }
                  id = {"ckbox_" + moment(day).format("D")}
                  checkedIcon = {
                    <CheckIcon
                      color = "accentY"
                      fontSize = "large"
                      sx = {{float: "right", mr: "0.3rem"}}
                    />
                  }
                  color = "default"
                  defaultChecked = {props.getValues(moment(day).format("D")).ptoStatus === "1"}
                  onClick = {(e) => {
                    props.setValue(moment(day).format("D"), {...props.getValues(moment(day).format("D")), ptoStatus: props.getValues(moment(day).format("D")).ptoStatus === "1" ? "0" : "1"});
                    e.stopPropagation();
                  }}
                  sx = {{p: 0, width: "100%"}}
                />
              </React.Fragment>
            }
            secondaryTypographyProps = {{component: "div"}}
            sx = {{mt: 0, mb: "auto", pl: 0.2}}
          >
          </ListItemText>
        </ListItemButton>
      </Grid>
    );
  };
  return calendar;
});

export default function PTOCalendar(props) {
  const limitDate = moment(new Date().toLocaleDateString()).format("yyyy-MM");
  const {getValues, reset, setValue} = useForm();
  const [open, setOpen] = React.useState({
    submitModal: false
  });
  const onClickSubmit = () => {
    let ptoRequestList = Object.keys(getValues()).filter((data) => getValues(data).ptoStatus === "1");
    setPTORequestUpdate({ymdDt: new Date(props.state.date).toLocaleDateString(), ptoRequestList: ptoRequestList}).then(response => {
      document.getElementById("request_leave_btn").click();
      props.setToastState({...props.toastState, error: false, message: response.data.message});
      props.parentSetState({...props.parentState, stopRender: true});
    }).catch(error => {
      props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
    });
    setOpen({...open, submitModal: !(open.submitModal)});
  };

  React.useEffect(() => {
    if (new Date(props.state.date + "-01").toLocaleDateString() !== "Invalid Date") {
      reset();
      getPTORequestList({ymdDt: new Date(props.state.date).toLocaleDateString()}).then(response => {
        Object.keys(response.data).map((data) => (
          setValue(data, response.data[data])
        ));
        setOpen({...open, submitModal: open.submitModal});
      }).catch(error => {
        props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
      });
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.state.date]);

  return (Object.keys(getValues()).length !== 0 &&
    <>
    <Grid
      container
      spacing = {0}
    >
      <CalendarBody
        getValues = {getValues}
        limitDate = {limitDate}
        setValue = {setValue}
        state = {props.state}
      />
    </Grid>
    <Box
      sx = {{display: "flex", mt: 2}}
    >
      <Button
        className = "btn-submit"
        disabled = {props.state.date <= limitDate}
        id = "request_leave_btn"
        onClick = {() => setOpen({...open, submitModal: !(open.submitModal)})}
        sx = {{ml: "auto", width: "48%"}}
      >
        <Typography
          className = "btn-txt-lg"
        >
          申請
        </Typography>
      </Button>
    </Box>
    <Modal
      open = {open.submitModal}
      closeAfterTransition
    >
      <Box
        className = "basic-modal"
      >
        <Typography>
          {moment(props.state.date).format("yyyy年MM月分")}
        </Typography>
        <Typography>
          選択した日付を休暇申請しますか？
        </Typography>
        <Box
          sx = {{textAlign: "right"}}
        >
          <Button
            onClick = {() => onClickSubmit()}
            sx = {{}}
          >
            はい
          </Button>
          <Button
            onClick = {() => setOpen({...open, submitModal: !(open.submitModal)})}
            sx = {{}}
          >
            いいえ
          </Button>
        </Box>
      </Box>
    </Modal>
    </>
  );
};
